// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__AI6mI","title":"AfterFrontImage_title__3W5k_"};